import React from "react";
import "./smallMultiBar.css";
import { Bar } from "react-chartjs-2";
import Dropdown from "../Components/dropdown";

const SmallMultiBar = ({
  options,
  monthsConsumption,
  monthsConsumption2,
  state,
  title,
  dropdown,
}) => {
  options = {
    responsive: true,

    plugins: {
      tooltip: {
        enabled: true, // <-- this option disables tooltips
      },
      legend: {
        display: false, // Hide the legend
      },
    },
    scales: {
      x: {
        stacked: true,
        ticks: { color: "#929292", font: { size: 10 }, padding: 5 },
        beginAtZero: true,
        grid: {
          display: false, // Extended vertical lines below x-axis only
          drawBorder: false,
        },
      },
      y: {
        stacked: true,
        ticks: { color: "#6C757D", font: { size: 12 } },
        beginAtZero: true,
        grid: {
          drawBorder: false, // <-- this removes y-axis line
        },
      },
    },
  };

  monthsConsumption = [200, 300, 269, 400, 600, 420, 333, 245, 500];

  monthsConsumption2 = [400, 200, 169, 300, 500, 320, 233, 145, 400];

  state = {
    data: {
      labels: ["AUG", "SEP", "OCT", "NOV", "DEC", "JAN", "FEB", "MAR", "APR"],
      datasets: [
        {
          stack: "Stack 0",
          label: "Active Users",
          backgroundColor: "#82CA6F",
          borderColor: "#82CA6F",
          borderWidth: 1,
          data: monthsConsumption,
          borderRadius: 7, // Round the top edges of bars
          barThickness: 14, // Width of the bars
        },
        {
          stack: "Stack 0",
          label: "Nonactive Users",
          backgroundColor: "#F39B3D",
          borderColor: "#F39B3D",
          borderWidth: 1,
          data: monthsConsumption2,
          borderRadius: 7, // Round the top edges of bars
          barThickness: 14, // Width of the bars
        },
      ],
    },
  };

  const balls = [
    { color: "#F39B3D", title: "Nonactive Users" },
    { color: "#82CA6F", title: "Active Users" },
  ];

  return (
    <div className="smallMultiBar">
      <div className="title">
        <span>{title}</span>
        {dropdown && <Dropdown data={dropdown} />}
      </div>
      <Bar height="240px" width="357px" options={options} data={state.data} />
      <div className="balls">
        {balls.map((ball, index) => (
          <div key={index} className="ball">
            <div
              className="color"
              style={{ backgroundColor: ball.color }}
            ></div>
            <span>{ball.title}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SmallMultiBar;
